<template>
  <div class="FavoriteButton relative">
    <button
      class="group transition-all duration-300 ease-out"
      :class="[
        'h-32 w-32 bg-bg-base/90 outline outline-1 outline-bg-inverse/10 group-hover:bg-bg-base/100 group-hover:outline-bg-inverse/20',
        {
          'bg-bg-base/100 outline-bg-inverse/20': anySelected,
          'opacity-100 hover:border-border-inverse': !anySelected && design !== 'cart',
          'border border-light hover:border-darkest': design === 'cart',
        }]"
      :title="anySelected ? $t('favorite.button.remove'):$t('favorite.button.add')"
      :disabled="loadingToFalse || loadingToTrue"
      @click.stop="onSelect"
    >
      <img
        :src="(anySelected || loadingToTrue) && !loadingToFalse ? '/icons/heart-filled.svg':'/icons/heart.svg'"
        class="FavoriteButtonIcon inline-block"
        :class="{
          'favoriteAnimateIn': (anySelected || loadingToTrue) && !loadingToFalse,
          'w-20 h-20 relative': design === 'small',
          'w-20 h-20': design === 'standard' || design === 'featured',
          'w-16 h-16 relative': (design === 'cart' || design === 'miniCart') && !anySelected,
          'w-16 h-16': (design === 'cart' || design === 'miniCart') && anySelected,
        }"
        alt=""
      >
    </button>

    <transition name="fade">
      <FavoriteDropdown
        v-if="showDropdown"
        :product="product"
        :design="design"
        @close="showDropdown = false"
      />
    </transition>
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from '~/store/user';

import { ref } from 'vue';
import { ProductModel } from '~/models/product';
import FavoriteDropdown from '~/components/product/FavoriteDropdown.vue';

const props = defineProps<{
  product: ProductModel | string; // if possible, use product, otherwise partno (from cart)
  design: 'standard' | 'featured' | 'small' | 'list' | 'cart' | 'hotSpot' | 'miniCart'
}>();

const userStore = useUserStore();
const loadingToTrue = ref(false);
const loadingToFalse = ref(false);
const showDropdown = ref(false);

/**
 * See if any of the variants have a selected
 */
const anySelected = computed(() => {
  const userFav = userStore.userProfile.favoriteProducts.map((m) => m.id);
  if (typeof props.product === 'string') {
    return userFav.includes(props.product);
  } else if (props.product.limitedVariantLoaded) {
    return userFav.includes(props.product.partNo);
  } else {
    return userFav.some((s) => props.product.partNumbers?.includes(s));
  }
});

const onSelect = async() => {
  const partNo = typeof props.product === 'string' ? props.product:props.product.partNo;

  if (typeof props.product !== 'string' && props.product.hasVariants && !props.product.limitedVariantLoaded) {
    showDropdown.value = !showDropdown.value;
  } else {
    if (anySelected.value) {
      // remove
      loadingToFalse.value = true;
      await userStore.updateFavoriteProductQuantity(partNo, 0);
      loadingToFalse.value = false;
    } else {
      loadingToTrue.value = true;
      await userStore.saveFavoriteProduct(partNo);
      loadingToTrue.value = false;
    }
  }
};

</script>

<style lang="postcss">
</style>
